import { useIsTrialer } from '@ctct/state-server-layer';

import { useIsSmsBundle } from './useIsSmsBundle';

/**
 * Returns whether the add-ons step should be hidden in the payflow.
 *
 * Add-ons are skipped for trialers on both mobile and desktop and for
 * users in the SMS-bundle URL flow
 */
export const useHideAddons = (): boolean => {
  const { data: isTrialer, isLoading: isTrialerLoading } = useIsTrialer();
  const isSmsBundle = useIsSmsBundle();

  return (!isTrialerLoading && !!isTrialer) || isSmsBundle;
};
